import React from 'react';
import Loader from 'src/components/loader';
import loadable from '@loadable/component';

const AccountManager = loadable(
  () => import(/* webpackChunkName: "user" */ './manager-hoc'),
  {
    fallback: <Loader />,
  }
);
const SettingsPage = loadable(
  () => import(/* webpackChunkName: "user" */ './settings'),
  {
    fallback: <Loader />,
  }
);
const SignupConfirm = loadable(
  () => import(/* webpackChunkName: "user" */ './confirm'),
  {
    fallback: <Loader />,
  }
);
const VerifyEmail = loadable(
  () => import(/* webpackChunkName: "user" */ './verify-email'),
  {
    fallback: <Loader />,
  }
);
const EmailChangeConfirm = loadable(
  () =>
    import(
      /* webpackChunkName: "user" */ './settings/components/email-change-confirm'
    ),
  {
    fallback: <Loader />,
  }
);
const RecoverLinkSent = loadable(
  () =>
    import(
      /* webpackChunkName: "user" */ './forgot-password/recover-link-sent'
    ),
  {
    fallback: <Loader />,
  }
);

export {
  AccountManager,
  SettingsPage,
  SignupConfirm,
  VerifyEmail,
  EmailChangeConfirm,
  RecoverLinkSent,
};
